import { IArticle } from '../components/pageBuilder/Sections/SectionFilterableArticles/types/SectionFilterableArticles.types';

export function compareByFeatured(a: IArticle, b: IArticle) {
  if (a.featured && !b.featured) {
    return -1;
  }

  if (!a.featured && b.featured) {
    return 1;
  }
  return 0;
}

export function compareByViewCount(a: IArticle, b: IArticle) {
  return b.viewCount - a.viewCount;
}

export function clearDisplayAsFeatured(articles: IArticle[]) {
  articles.forEach((article: IArticle) => {
    article.displayAsFeatured = false;
  });
  return articles;
}
